import { render, staticRenderFns } from "./ConsultBranchesPage.vue?vue&type=template&id=075cf06f"
import script from "./ConsultBranchesPage.vue?vue&type=script&lang=ts"
export * from "./ConsultBranchesPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultBranchesPage.vue?vue&type=style&index=0&id=075cf06f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports